import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from './base/index';
import GlossaryTerm from './GlossaryTerm';
import useGlossaryHandler from '../hooks/useGlossaryHandler';
import { debugLog } from '../utils/index';
import { PageStateContext } from '../PageContext';

const GlossaryTerms = ({ glossaryIds }) => {
  const { isValidTermId } = useGlossaryHandler();
  const { pageState } = useContext(PageStateContext);
  const { uiText } = pageState;
  debugLog('glossaryIds', glossaryIds);
  // Compute validGlossaryIds using useMemo
  const validGlossaryIds = useMemo(() => {
    return glossaryIds.filter((termId) => isValidTermId(termId));
  }, [glossaryIds, isValidTermId]);

  // If no valid glossary terms, render nothing
  if (validGlossaryIds.length === 0) {
    return null;
  }

  return (
    <div className="glossary-definitions mt-6 mb-4">
      <Text
        tag="label"
        className="text-blue-accent mb-4 break-after-avoid"
      >
        {uiText.glossary_definitions}
      </Text>
      {validGlossaryIds.map((termId) => (
        <GlossaryTerm key={termId} termId={termId} />
      ))}
    </div>
  );
};

GlossaryTerms.propTypes = {
  glossaryIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GlossaryTerms;